import {SessionStorage} from '@chekin/core';
import {IS_LEADER_GUEST_STORAGE_KEY} from './constants';

class LeaderGuestFlag {
  private static parse(value: unknown): boolean | undefined {
    if (typeof value === 'boolean') return value;
    if (value === 'true') return true;
    if (value === 'false') return false;
    return undefined;
  }

  private static getFromUrl(): boolean | undefined {
    const {search, hash} = window.location;
    const fromSearch = new URLSearchParams(search).get(IS_LEADER_GUEST_STORAGE_KEY);
    if (fromSearch !== null) return LeaderGuestFlag.parse(fromSearch);

    const hashQueryIndex = hash.indexOf('?');
    if (hashQueryIndex === -1) return undefined;

    const hashParams = new URLSearchParams(hash.slice(hashQueryIndex + 1));
    return LeaderGuestFlag.parse(hashParams.get(IS_LEADER_GUEST_STORAGE_KEY));
  }

  static get(): boolean | undefined {
    return (
      LeaderGuestFlag.getFromUrl() ??
      LeaderGuestFlag.parse(SessionStorage.get(IS_LEADER_GUEST_STORAGE_KEY))
    );
  }

  static persist(isLeader?: boolean): void {
    if (isLeader === undefined) {
      LeaderGuestFlag.clear();
      return;
    }
    SessionStorage.set(IS_LEADER_GUEST_STORAGE_KEY, isLeader);
  }

  static clear(): void {
    SessionStorage.remove(IS_LEADER_GUEST_STORAGE_KEY);
  }

  static appendToPath(path: string, isLeader?: boolean): string {
    if (isLeader === undefined) return path;
    const separator = path.includes('?') ? '&' : '?';
    return `${path}${separator}${IS_LEADER_GUEST_STORAGE_KEY}=${isLeader}`;
  }
}

export {LeaderGuestFlag};
